import { useQuery } from '@pinia/colada';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import accessInstructionsService from '../services/access-instructions.service';

export function getPropertyAccessInstructionsQueryKey(propertyId: string) {
  return ['property', propertyId, 'access-instructions'];
}

export function usePropertyAccessInstructionsQuery(propertyId?: () => string | undefined) {
  const route = useRoute();
  const resolvedPropertyId = computed(() => propertyId?.() ?? (route.params.propertyId as string));

  return useQuery({
    key: () => getPropertyAccessInstructionsQueryKey(resolvedPropertyId.value),
    enabled: () => Boolean(resolvedPropertyId.value),
    query: () => accessInstructionsService.getByProperty(resolvedPropertyId.value),
  });
}
